import * as React from "react";

function SvgComplete(props) {
  return <svg viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><circle stroke="#FF6400" strokeWidth={1.667} fill="#FF6400" cx={21} cy={21} r={20} /><path stroke="#FFF" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" d="M12.667 21.275l5.696 5.696L29.333 16" /></g></svg>;
}

export default SvgComplete;